<template>
    <div
        v-if="user !== null"
        class="col-12 col-lg-9 col-xl-7">
        <div class="card">
            <div class="card-header">アカウント退会</div>
            <div class="card-body">
                <div class="leaveNotice">
                    <p class="leaveNoticeLead">{{ serviceName }}「{{ $locale.appNameJa }}」のアカウントを退会します。<br>この操作は取り消すことができません。</p>
                    <p class="text-center">下記の注意事項に同意の上、画面最下部の「{{ $locale.appNameJa }}アカウントを退会する」ボタンをタップしてください。</p>

                    <div class="leaveNoticeCenter mt-5 mb-5">
                        <p class="mb-5">
                            【注意事項】<br>
                            退会されたアカウントは復旧することができません。<br>
                            アカウント退会後は予約履歴、{{ $locale.consultation_host }}履歴、{{ $locale.consultation_host }}記録の閲覧ができなくなると同時に、登録済みの個人情報が削除されます。<br>
                            なお、入力いただいたアンケートやご感想、無料質問及びその回答等につきましては削除されません。
                        </p>

                        <p>※&nbsp;以下の方はアカウントを退会することができません。<a :href="contactUrl" target="_blank">お問い合わせ</a>よりご相談ください。</p>

                        <ul class="leaveNoticeList">
                            <li v-if="$locale.type === 'consul'">法人契約会員</li>
                            <li v-if="$locale.type === 'consul'">パートナー経由でご登録された会員</li>
                            <li>未払いの{{ $locale.consultation_host }}がある会員</li>
                        </ul>
                    </div>

                    <div class="d-flex justify-content-center mt-4 mb-4">
                        <button
                            class="btn btn-danger"
                            :disabled="inProgress"
                            @click="leave">
                            {{ $locale.appNameJa }}アカウントを退会する
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'
    import constants from '../../constants'

    export default {
        name: 'UserLeave',

        props: {
            dataUser: {
                type: Object,
                default: {},
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                user: null,
                inProgress: false,
                errors: {},
            };
        },

        computed: {
            /**
             * サービス名称
             *
             * @return {string}
             */
            serviceName: function () {
                return this.$locale.type === 'consul' ? '海外オンライン医療相談サービス' : 'オンライン診療サービス'
            },

            /**
             * 問い合わせURL
             *
             * @return {string}
             */
            contactUrl: function () {
                return this.$locale.type === 'consul' ? 'https://yokumiru.jp/contact-kojin' : 'https://ent.yokumiru.jp/contact/'
            },
        },

        created: function () {
            this.user = { ...this.dataUser }
        },

        methods: {
            /**
             * アカウント退会
             */
            leave: async function () {
                if (this.inProgress) return
                this.inProgress = true

                await axios.delete(constants.user.leave.endpoint.base)
                    .then(() => {
                        window.location.href = '/login'
                    })
                    .catch(({response}) => {
                        if (response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            if (response.data.errors.hasOwnProperty('message')) {
                                this.errors = {}
                                bus.$emit('alert-danger', response.data.errors.message[0])
                            }
                            else {
                                this.errors = response.data.errors
                                bus.$emit('alert-danger')
                            }
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },
        },
    }
</script>

<style scoped lang="scss">
.leaveNotice {
    p, ul {
        font-size: 16px;
    }

    .leaveNoticeLead {
        margin: 20px 0 30px;
        font-size: 21px;
        font-weight: bold;
        line-height: 1.35;
        text-align: center;
    }

    .leaveNoticeCenter {
        max-width: 880px;
        margin: 0 auto;
    }

    .leaveNoticeList {
        padding: 20px;
        background-color: #F7F7F7;
        border-radius: 10px;

        li {
            margin-left: 15px;
        }
    }
}
</style>
